module.exports = __webpack_public_path__ + "img/car-2.cb24ccf4.jpg";